export function buildBetaFeedbackMailto(params?: {
  subject?: string;
  workflow?: string;
  registrars?: string[];
  portfolioSize?: string;
  teamSize?: string;
  problem?: string;
  expected?: string;
}): string {
  const subject = encodeURIComponent(params?.subject || "DN.place beta feedback");
  const body = encodeURIComponent(
    [
      `Workflow: ${params?.workflow || ""}`,
      `Registrars used: ${(params?.registrars || []).join(", ")}`,
      "",
      "What were you trying to do?",
      "",
      "What blocked you or felt confusing?",
      params?.problem || "",
      "",
      "What outcome did you expect instead?",
      params?.expected || "",
      "",
      `Portfolio size: ${params?.portfolioSize || ""}`,
      `Team size: ${params?.teamSize || ""}`,
    ].join("\n")
  );

  return `mailto:support@dn.place?subject=${subject}&body=${body}`;
}
